import { useEffect, useState } from 'react'
import firebase from '../firebase/compat'

// De MRR-cijfers voor het beheerdersdashboard, via de callable
// getPlatformRevenue. Bewust GEEN Firestore-listener zoals usePlatformStats:
// PlatformRevenue staat volledig dicht omdat het om omzet gaat, en de
// tenantcontrole hoort server-side. Zie docs/features/platform-mrr-card.md
//
// Eenmalige ophaling, geen live-abonnement — het cijfer verandert één keer per
// nacht. `error` blijft staan als hij faalt: stil terugvallen op null zou er op
// de tegel uitzien als 'nog geen omzet'.
//
// AI-CONTEXT: See docs/features/platform-mrr-card.md

/**
 * @returns {{current: object|null, history: Array<object>, loading: boolean, error: string|null}}
 */
const usePlatformRevenue = () => {
    const [current, setCurrent] = useState(/** @type {object | null} */ (null))
    const [history, setHistory] = useState(/** @type {Array<object>} */ ([]))
    const [loading, setLoading] = useState(true)
    const [error, setError] = useState(/** @type {string | null} */ (null))

    useEffect(() => {
        let cancelled = false

        const fetch = async () => {
            try {
                // v2-functie in europe-west1 — region expliciet, anders belt de
                // SDK us-central1 en bestaat de functie daar niet.
                const getPlatformRevenue = firebase.app().functions('europe-west1').httpsCallable('getPlatformRevenue')
                const result = await getPlatformRevenue({})
                if (cancelled) return
                setCurrent(result.data?.current || null)
                setHistory(Array.isArray(result.data?.history) ? result.data.history : [])
            } catch (err) {
                console.error('usePlatformRevenue error:', err)
                if (cancelled) return
                setError(err.message || 'Kon de omzetcijfers niet ophalen.')
            } finally {
                if (!cancelled) setLoading(false)
            }
        }

        fetch()
        return () => { cancelled = true }
    }, [])

    return { current, history, loading, error }
}

export default usePlatformRevenue
